import type { Pool, PoolResources } from "~types/pool.ts";
import type { SeasonPoolTransformed } from "../types/seasonPoolTransformed.ts";
import { transformSeasonPool } from "./transformSeasonPool.ts";

export const transformSeasonPools = (items: Pool[], resources: PoolResources | undefined, seasonId: string): SeasonPoolTransformed[] =>
  items.map((item) => transformSeasonPool(item, resources, seasonId));
